import { createSlice } from "@reduxjs/toolkit";
import { createProduct, getProductById, mergeProducts, searchProducts, updateProduct } from "../api/product";

interface ProductState {
    loading: boolean;
    currentRequestId: undefined | string;
    userData: any;
    error: any;
}

const initialState = {
    loading: false,
    currentRequestId: undefined,
    userData: null,
    error: null,
} as ProductState;


export const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        resetProductState: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(searchProducts.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(searchProducts.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(searchProducts.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(getProductById.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(getProductById.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(getProductById.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(createProduct.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(createProduct.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(createProduct.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(updateProduct.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(updateProduct.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(updateProduct.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(mergeProducts.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(mergeProducts.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(mergeProducts.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
    }
})

export const { resetProductState } = productSlice.actions;

export default productSlice.reducer;